module.exports = __webpack_public_path__ + "static/capacitacao-527e4aa44e9193301fba1dd03d3e9cd1.jpg";